import { render, staticRenderFns } from "./DrugLandingStatsList.vue?vue&type=template&id=1080f3fa&"
import script from "./DrugLandingStatsList.vue?vue&type=script&lang=js&"
export * from "./DrugLandingStatsList.vue?vue&type=script&lang=js&"
import style0 from "./DrugLandingStatsList.vue?vue&type=style&index=0&id=1080f3fa&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1080f3fa')) {
      api.createRecord('1080f3fa', component.options)
    } else {
      api.reload('1080f3fa', component.options)
    }
    module.hot.accept("./DrugLandingStatsList.vue?vue&type=template&id=1080f3fa&", function () {
      api.rerender('1080f3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/statistics/druglanding-stast-view/DrugLandingStatsList.vue"
export default component.exports